<template>
  <div>
    <div class="rate-container">
      <div class="rate-wrap" :class="`rate-limit-${maxAllowed}`">
      <el-rate
        :max="5"
        v-model="rank_score"
        :texts="['1分', '2分', '3分', '4分', '5分']"
        @change="changeRankScore"
        @mouseleave="rank_score = Math.min(rank_score, maxAllowed)"
        show-text>
      </el-rate>
      </div>
      <el-button type="text" style="color: #333" @click="dialogVisible = !dialogVisible">
        <i class="el-icon-question" style="color: #F56C6C"/>打分标准
      </el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      width="60%">
      <el-alert
        class="tip"
        type="warning"
        :closable="false">
        <div class="standard-text-content" style="margin-bottom: 20px">
          <p style="font-weight: bold; color: #333; font-size: 13px;">关于用户做单质量综合评分的审核指引：</p>
          <p>致审核伙伴们，为了更精准地评估用户做单质量，请您在评审时，从以下5个方面进行综合考量，并给出一个整体打分：</p>
        </div>
        <div class="standard-it">
          <div class="st-title"><span>1.完整性：</span>考察任务是否被完美执行</div>
          <div class="standard-text-content">例如：要求提交完整的全景照片，提交的凭证是否需要通过拼凑才能勉强达标？</div>
        </div>
        <div class="standard-it">
          <div class="st-title"><span>2.清晰度：</span>考察提交的证据是否清晰可辨识</div>
          <div class="standard-text-content">例如：图片是否模糊、拍摄顺序是否混乱？</div>
        </div>
        <div class="standard-it">
          <div class="st-title"><span>3.对应性：</span>考察证据与题目的关联性和支持度</div>
          <div class="standard-text-content">例如：所提交的证据是否与题目有对应关系？</div>
        </div>
        <div class="standard-it">
          <div class="st-title"><span>4.流畅感：</span>考察整个做单过程是否顺畅、合规、专业</div>
          <div class="standard-text-content">例如：跳步、投机取巧或违反常规流程做扣分处理</div>
        </div>
        <div class="standard-it">
          <div class="st-title"><span>5.沟通类任务：</span>考察用户的沟通技巧与专业形象</div>
          <div class="standard-text-content">例如：穿着是否整洁、语言是否礼貌、是否巧妙流畅获取任务的需求点？</div>
        </div>
        <div class="standard-text-content">
          最终评分是您基于上述所有因素形成的整体判断。请运用您的专业经验，权衡轻重，给出最符合该单整体质量的分数。感谢您的付出！
        </div>
      </el-alert>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    orderDetail: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      rank_score: null,
      dialogVisible: false,
    }
  },
  computed: {
    maxAllowed () {
      return Math.max(5 - this.orderDetail.review, 1)
    }
  },
  watch: {
    rank_score (val) {
      if (val > this.maxAllowed) {
        this.rank_score = this.maxAllowed
      }
    },
    maxAllowed () {
      if (this.rank_score !== null && this.rank_score > this.maxAllowed) {
        this.rank_score = this.maxAllowed
      }
    },
  },
  methods: {
    changeRankScore (value) {
      if (value > this.maxAllowed) {
        this.$message.error(`订单曾被退回，最多可打${this.maxAllowed}分，每退回一次将扣分`)
        this.rank_score = 0
        this.$emit('input', 0)
      } else {
        this.$emit('input', value)
      }
    },
  }
}
</script>

<style scoped>
/deep/ .el-rate {
  height: 40px;
  .el-rate__icon {
    font-size: 30px;
  }
  .el-rate__text {
    font-size: 24px;
  }
}

/* ========== 核心：动态禁用星星样式（Vue2 标准写法） ========== */
/* 档位1：最多选1星 → 第2~5颗星禁用 */
.rate-limit-1 /deep/ .el-rate__item:nth-child(n+2) .el-rate__icon {
  color: #ebeef5 !important;
}
.rate-limit-1 /deep/ .el-rate__item:nth-child(n+2) {
  pointer-events: none !important;
  cursor: not-allowed !important;
}
/* 档位2：最多选2星 → 第3~5颗星禁用（你当前测试档位） */
.rate-limit-2 /deep/ .el-rate__item:nth-child(n+3) .el-rate__icon {
  color: #ebeef5 !important;
}
.rate-limit-2 /deep/ .el-rate__item:nth-child(n+3) {
  pointer-events: none !important;
  cursor: not-allowed !important;
}
/* 档位3：最多选3星 → 第4~5颗星禁用 */
.rate-limit-3 /deep/ .el-rate__item:nth-child(n+4) .el-rate__icon {
  color: #ebeef5 !important;
}
.rate-limit-3 /deep/ .el-rate__item:nth-child(n+4) {
  pointer-events: none !important;
  cursor: not-allowed !important;
}
/* 档位4：最多选4星 → 第5颗星禁用 */
.rate-limit-4 /deep/ .el-rate__item:nth-child(n+5) .el-rate__icon {
  color: #ebeef5 !important;
}
.rate-limit-4 /deep/ .el-rate__item:nth-child(n+5) {
  pointer-events: none !important;
  cursor: not-allowed !important;
}
/* 档位5：全部可点击，恢复默认 */
.rate-limit-5 /deep/ .el-rate__item {
  pointer-events: auto !important;
  cursor: pointer !important;
}

.standard-text-content {
  color: rgba(0, 0, 0, 0.4);
}

.standard-it {
  margin-bottom: 20px;

  & .st-title {
    font-weight: bold;
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 4px;

    & span {
      color: rgba(255, 143, 31, 1);
    }
  }
}

.rate-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.tip {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReviewSidebarPanel/OrderRank.vue